import { usePersonalSettings } from '../PersonalSettingsContext';
import { PersonalSettingsPreferenceListConsumerContainer } from './PersonalSettingsPreferenceListConsumerContainer';

export function PersonalSettingsPreferenceListConsumerContainerWrapper() {
    const { personalSettingsData, isReadOnly } = usePersonalSettings();

    const organizationId = personalSettingsData?.organization.id;

    return (
        <PersonalSettingsPreferenceListConsumerContainer
            isReadOnly={isReadOnly}
            organizationId={organizationId}
        />
    );
}
